if (!customElements.get('size-guide-link')) {
  customElements.define(
    'size-guide-link',
    class SizeGuideLink extends HTMLElement {
      constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
      }

      connectedCallback() {
        this.link = this.querySelector('[data-size-guide-link]');
        this.template = this.querySelector('[data-size-guide-template]');

        if (this.link) {
          this.link.addEventListener('click', this.handleClick);
        }
      }

      disconnectedCallback() {
        if (this.link) {
          this.link.removeEventListener('click', this.handleClick);
        }
      }

      handleClick(event) {
        if (!this.link) return;

        event.preventDefault();

        const href = this.link.getAttribute('href');
        const hasUsableHref = href && href !== '#';
        const payload = {
          title: this.link.dataset.sizeGuideTitle || this.link.textContent.trim(),
          url: hasUsableHref ? this.link.href : '',
          html: this.template ? this.template.innerHTML.trim() : '',
          source: this
        };

        if (window.eventBus && typeof window.eventBus.emit === 'function') {
          window.eventBus.emit('open:size:guide', payload);
          return;
        }

        document.dispatchEvent(new CustomEvent('open:size:guide', { detail: payload }));
      }
    }
  );
}
